import { z } from 'zod';
import { CAL_EVENT_MAX_TAGS } from '../../events/cal-event-max-tags.js';
import { requiredUuidString } from '../zod-helpers/index.js';
export const calEventTagIdsSchema = z
    .array(requiredUuidString('Tag is required.', 'Invalid tag ID.'))
    .max(CAL_EVENT_MAX_TAGS, `An event can have at most ${CAL_EVENT_MAX_TAGS} tags.`)
    .refine((ids) => new Set(ids).size === ids.length, 'Each tag can only be added once.');
//# sourceMappingURL=cal-event-tag-ids-schema.js.map